// extracted by mini-css-extract-plugin
export const header = "storage-module--header--NfJZ6";
export const description = "storage-module--description--k9FVj";
export const list = "storage-module--list--14tRe";